import { useMocks } from '../../shared/env';
import type { EmployeeReadinessGateway } from './EmployeeReadinessGateway';
import { HttpEmployeeReadinessGateway } from './HttpEmployeeReadinessGateway';
import { MockEmployeeReadinessGateway } from './MockEmployeeReadinessGateway';

export const employeeReadinessGateway: EmployeeReadinessGateway = useMocks
  ? new MockEmployeeReadinessGateway()
  : new HttpEmployeeReadinessGateway();
